<div class="logout">
  <h2 align="center">Logout</h2>
  <h3 mat-dialog-title>Do you want to Logout?</h3>
  <div>
    <mat-dialog-actions align="end">
      <button mat-button mat-raised-button mat-dialog-close>No</button>
      <button mat-button mat-raised-button color="primary" (click)="exit()">
        Yes
      </button>
    </mat-dialog-actions>
  </div>
</div>
